<div class="modelContainer alignCenter">  
  <div *ngIf="isLoader" class="svg-loader"></div>
  <div class="">
    <button (click)="onCancelClick()" type="button" class="close cancelBtn" typeof="button" aria-label="Close"
      mat-dialog-close>
      Close
    </button>
  </div>
  <div class="modelTitle">
    <span *ngIf="mode == 'add'">Add Constant</span>
    <span *ngIf="mode == 'edit'">Edit Constant - {{data.constantId}}</span>
  </div>
  <div class="modelBody">
    <form [formGroup]="constantsForm">
      <div class="form-spacing justify-content-center flex-column">
        <div class="row display-flex">
          <div class="col-5"><label for="constantId" class="mandatory-field margin-top-5 regularText"><strong>Name</strong></label></div>
          <div class="col-12">
            <input type="text" class="form-control regularText" id="constId" formControlName="constantId" (keyup)="onNameSave()" />
          </div>          
        </div>
        <div class="row mt-3 display-flex">
          <div class="col-5"><label for="value" class="mandatory-field regularText"><strong>Value</strong></label></div>
          <div class="col-12">
            <input type="text" class="form-control regularText" id="constValue" formControlName="value" (keyup)="onValueSave()" />
          </div>
        </div>
        <div class="row mt-3 display-flex">
          <div class="col-5"><label for="unitType" class="mandatory-field regularText"><strong>UOM Type</strong></label></div>
          <div class="col-12">
            <select class="form-control select-btn regularText" name="unitType" formControlName="unitType" (change)="populateUOM()" required>
              <option value="">--Select--</option>
              <option *ngFor="let uomType of unitTypeList" [ngValue]="uomType">{{uomType}}</option>
            </select>
          </div>
        </div>
        <div class="row mt-3 display-flex">
          <div class="col-5"><label for="uom" class="mandatory-field regularText"><strong>UOM</strong></label></div>
          <div class="col-12">
            <select id="engUnits" class="form-control select-btn regularText" required formControlName="uom">
              <option value="">--Select--</option>
              <option *ngFor="let element of unitList" [ngValue]="element">{{element}}</option>
            </select>
          </div>
        </div>
        <div class="row mt-3 display-flex">
          <div class="col-12 text-center">
            <button aria-label="Close" class="saveBtn2" (click)="saveFormula()" [disabled]="enableSave()">
              <span aria-hidden="true">Save</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
